/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Perpendicular edge w.r.t. plane</h4>

<p>Make an edge perpendicular to a face, or plane.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('703231449')}" loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function EdgeToPlanePerpendicularTooltip() {
    return h('div', { innerHTML: body });
}
